export { PRODUCT_FAMILY_SA as SA_PRODUCT_CODE } from './productFamily';
export const BUYER_SUBSCRIPTION_TYPE = 'BUYER';
export const SELLER_SUBSCRIPTION_TYPE = 'SELLER';
